import { render } from "./OpsChangeInboxDetail.vue?vue&type=template&id=f1fc867e&scoped=true"
import script from "./OpsChangeInboxDetail.vue?vue&type=script&lang=js"
export * from "./OpsChangeInboxDetail.vue?vue&type=script&lang=js"

import "./OpsChangeInboxDetail.vue?vue&type=style&index=0&id=f1fc867e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fc867e"]])

export default __exports__